(function () {
  var mobileQuery = window.matchMedia('(max-width: 850px)');
  var momentsAutoplaySpeed = 3000;

  function getSpacing() {
    return 13 * window.innerWidth / 390;
  }

  function getMomentsSpacing() {
    return 9 * window.innerWidth / 390;
  }

  function setButtonState(button, disabled) {
    if (!button) return;
    button.classList.toggle('swiper-button-disabled', disabled);
    button.disabled = disabled;
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function createArrow(className, label, path) {
    var button = document.createElement('button');
    button.className = 'swiper-arrow ' + className;
    button.type = 'button';
    button.setAttribute('aria-label', label);
    button.innerHTML = '<svg viewBox="0 0 27 27" aria-hidden="true" focusable="false"><path d="' + path + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    return button;
  }

  function setupPromoSwiper(layout) {
    if (!mobileQuery.matches || !layout.mySwiper || layout.__cr7PromoSwiper === layout.mySwiper) {
      return;
    }

    var promo = layout.closest('.c-luo-promos');
    var buttonContainer = promo && promo.querySelector('.bottom-btn-container');
    var swiper = layout.mySwiper;

    if (!promo || !buttonContainer || !swiper) {
      return;
    }

    var prevButton = buttonContainer.querySelector('.cr7-promo-arrow-prev');
    var nextButton = buttonContainer.querySelector('.cr7-promo-arrow-next');

    if (!prevButton) {
      prevButton = createArrow('cr7-promo-arrow-prev', 'Previous slide', 'M15.6 8.8L10.9 13.5L15.6 18.2');
      buttonContainer.insertBefore(prevButton, buttonContainer.firstChild);
    }

    if (!nextButton) {
      nextButton = createArrow('cr7-promo-arrow-next', 'Next slide', 'M11.4 8.8L16.1 13.5L11.4 18.2');
      buttonContainer.insertBefore(nextButton, prevButton.nextSibling);
    }

    function updateButtons() {
      setButtonState(prevButton, swiper.isBeginning);
      setButtonState(nextButton, swiper.isEnd);
    }

    swiper.params.slidesPerView = 'auto';
    swiper.params.spaceBetween = getSpacing();
    swiper.update();

    prevButton.onclick = function () {
      swiper.slidePrev();
    };

    nextButton.onclick = function () {
      swiper.slideNext();
    };

    swiper.on('slideChange', updateButtons);
    swiper.on('reachBeginning', updateButtons);
    swiper.on('reachEnd', updateButtons);
    swiper.on('fromEdge', updateButtons);
    window.addEventListener('resize', function () {
      if (!mobileQuery.matches) return;
      swiper.params.spaceBetween = getSpacing();
      swiper.update();
      updateButtons();
    });

    updateButtons();
    layout.__cr7PromoSwiper = swiper;
  }

  function getMomentsSwiper(swiperEl) {
    return swiperEl && (swiperEl.swiper || swiperEl.mySwiper);
  }

  function setSwiperBreakpointSlides(swiper, value) {
    if (!swiper.params.breakpoints) return;
    Object.keys(swiper.params.breakpoints).forEach(function (breakpoint) {
      swiper.params.breakpoints[breakpoint].slidesPerView = value;
    });
  }

  function updateMomentsButtons(swiper, prevButton, nextButton) {
    var disabled = !swiper;
    setButtonState(prevButton, disabled);
    setButtonState(nextButton, disabled);
  }

  function setMomentsAutoplayDirection(swiper, direction) {
    if (!swiper) return;

    var moveRight = direction === 'right';
    var autoplayParams = swiper.params && swiper.params.autoplay;

    if (
      swiper.autoplay &&
      autoplayParams &&
      typeof swiper.autoplay.stop === 'function' &&
      typeof swiper.autoplay.start === 'function'
    ) {
      swiper.autoplay.stop();
      autoplayParams.reverseDirection = moveRight;
      autoplayParams.disableOnInteraction = false;
      swiper.params.speed = momentsAutoplaySpeed;

      if (moveRight) {
        swiper.slidePrev(momentsAutoplaySpeed);
      } else {
        swiper.slideNext(momentsAutoplaySpeed);
      }

      swiper.autoplay.start();
      return;
    }

    if (moveRight) {
      swiper.slidePrev();
    } else {
      swiper.slideNext();
    }
  }

  function setupMomentsButtons(moments, swiper) {
    var buttonContainer = moments.querySelector('.cr7-moments-buttons');

    if (!buttonContainer) {
      buttonContainer = document.createElement('div');
      buttonContainer.className = 'cr7-moments-buttons';
      moments.querySelector('.h12-swiper-container').appendChild(buttonContainer);
    }

    var prevButton = buttonContainer.querySelector('.cr7-moments-arrow-prev');
    var nextButton = buttonContainer.querySelector('.cr7-moments-arrow-next');

    if (!prevButton) {
      prevButton = createArrow('cr7-moments-arrow-prev', 'Previous moment', 'M15.6 8.8L10.9 13.5L15.6 18.2');
      buttonContainer.appendChild(prevButton);
    }

    if (!nextButton) {
      nextButton = createArrow('cr7-moments-arrow-next', 'Next moment', 'M11.4 8.8L16.1 13.5L11.4 18.2');
      buttonContainer.appendChild(nextButton);
    }

    prevButton.onclick = function () {
      setMomentsAutoplayDirection(swiper, 'left');
    };

    nextButton.onclick = function () {
      setMomentsAutoplayDirection(swiper, 'right');
    };

    if (!swiper.__cr7MomentsButtonsBound) {
      swiper.on('slideChange', function () {
        updateMomentsButtons(swiper, prevButton, nextButton);
      });
      swiper.on('reachBeginning', function () {
        updateMomentsButtons(swiper, prevButton, nextButton);
      });
      swiper.on('reachEnd', function () {
        updateMomentsButtons(swiper, prevButton, nextButton);
      });
      swiper.on('fromEdge', function () {
        updateMomentsButtons(swiper, prevButton, nextButton);
      });
      swiper.__cr7MomentsButtonsBound = true;
    }

    updateMomentsButtons(swiper, prevButton, nextButton);
  }

  function mergeMomentsRows(moments) {
    var leftWrapper = moments.querySelector('.left-swiper .swiper-wrapper');
    var rightSlides = moments.querySelectorAll('.right-swiper .swiper-slide:not(.swiper-slide-duplicate)');

    if (!leftWrapper || !rightSlides.length || leftWrapper.querySelector('[data-cr7-moment-merged="true"]')) {
      return;
    }

    rightSlides.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('data-cr7-moment-merged', 'true');
      leftWrapper.appendChild(clone);
    });
  }

  function unmergeMomentsRows(moments) {
    moments.querySelectorAll('[data-cr7-moment-merged="true"]').forEach(function (slide) {
      slide.parentNode.removeChild(slide);
    });
  }

  function refreshMomentsSwiper(swiper, moments, isPrimary) {
    if (!swiper) {
      return !!swiper;
    }

    swiper.params.slidesPerView = 'auto';
    setSwiperBreakpointSlides(swiper, 'auto');

    if (mobileQuery.matches) {
      if (!isPrimary) {
        if (swiper.autoplay && swiper.autoplay.stop) {
          swiper.autoplay.stop();
        }
        return true;
      }

      if (swiper.loopDestroy) {
        swiper.loopDestroy();
      }

      mergeMomentsRows(moments);

      swiper.params.loopAdditionalSlides = 10;
      swiper.params.loopedSlides = 10;
      swiper.params.loop = true;
      swiper.params.centeredSlides = false;
      swiper.params.spaceBetween = getMomentsSpacing();
      swiper.params.allowTouchMove = true;
      swiper.params.speed = momentsAutoplaySpeed;

      if (swiper.loopCreate) {
        swiper.loopCreate();
      }

      swiper.update();

      if (swiper.autoplay && swiper.autoplay.start) {
        swiper.autoplay.start();
      }

      setupMomentsButtons(moments, swiper);
      swiper.__cr7MomentsManual = false;

      return true;
    }

    if (swiper.loopDestroy) {
      swiper.loopDestroy();
    }

    unmergeMomentsRows(moments);

    swiper.params.loopAdditionalSlides = 10;
    swiper.params.loopedSlides = 10;
    swiper.params.loop = true;
    swiper.params.centeredSlides = true;
    swiper.params.spaceBetween = 30;

    if (swiper.loopCreate) {
      swiper.loopCreate();
    }

    swiper.update();

    if (swiper.autoplay && swiper.autoplay.start) {
      swiper.autoplay.start();
    }

    swiper.__cr7MomentsManual = false;
    return true;
  }

  function setupMomentsLoop() {
    var moments = document.querySelector('.c-luo-moments');
    if (!moments) return false;

    var swipers = moments.querySelectorAll('.left-swiper .swiper, .right-swiper .swiper');
    if (!swipers.length) return false;

    var readyCount = 0;
    swipers.forEach(function (swiperEl, index) {
      if (refreshMomentsSwiper(getMomentsSwiper(swiperEl), moments, index === 0)) {
        readyCount += 1;
      }
    });

    return readyCount === swipers.length;
  }

  function initPromoCards() {
    document.querySelectorAll('.c-luo-promos new-common-image-layout').forEach(function (layout) {
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        setupPromoSwiper(layout);
        if (layout.__cr7PromoSwiper === layout.mySwiper || attempts > 40) {
          window.clearInterval(timer);
        }
      }, 100);
    });
  }

  function initMomentsLoop() {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (setupMomentsLoop() || attempts > 40) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  function initCr7Page() {
    initPromoCards();
    initMomentsLoop();
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', initCr7Page);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(initCr7Page);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCr7Page);
  } else {
    initCr7Page();
  }
})();
